import { useState, useCallback } from 'react';
import { publishTaskDocument } from '../../services/TaskService';

export const usePublishTaskDocument = () => {
  const [isPublishing, setIsPublishing] = useState(false);
  const [publishError, setPublishError] = useState(null);
  const [lastPublishedTask, setLastPublishedTask] = useState(null);

  const publish = useCallback(async (taskId) => {
    setIsPublishing(true);
    setPublishError(null);

    try {
      const result = await publishTaskDocument(taskId);
      setLastPublishedTask(result);

      return {
        ok: true,
        data: result,
      };
    } catch (error) {
      console.error('Error publicando documento de la tarea:', error);
      setPublishError(error);

      return {
        ok: false,
        error,
      };
    } finally {
      setIsPublishing(false);
    }
  }, []);

  return {
    publish,
    isPublishing,
    publishError,
    lastPublishedTask,
  };
};
